import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo, useRef } from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import {
    isOverflowingX,
    useTruncationTooltip,
} from "@design-system/Tooltip/useTruncationTooltip";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { useBreakableText } from "@hooks/useBreakableText";
import { TransactionStatus } from "../TransactionStatus";
import { CashItemIndicator } from "./CashItemIndicator";
import styles from "./BankDescriptionCell.module.scss";

export const BankDescriptionCell = memo(
    ({ row }: CellContext<ViewTableFeatures, TransactionListItem, any>) => {
        const { bankDescription } = row.original;
        const breakableDescription = useBreakableText(bankDescription);
        const textRef = useRef<HTMLSpanElement>(null);
        const truncationTooltipProps = useTruncationTooltip({
            ref: textRef,
            isTruncated: isOverflowingX,
        });

        return (
            <ViewTableCell className={styles.bankDescriptionCell}>
                <Tooltip
                    side="top"
                    content={bankDescription}
                    {...truncationTooltipProps}
                >
                    <span ref={textRef} className={styles.bankDescriptionText}>
                        {breakableDescription}
                    </span>
                </Tooltip>
                <CashItemIndicator transaction={row.original} />
                <TransactionStatus transaction={row.original} />
            </ViewTableCell>
        );
    },
);
BankDescriptionCell.displayName = "BankDescriptionCell";
